<?php

Namespace Controller ;

class LandingPageController extends \Controller\Base {

    public function execute($pageVars) {
        $page_model = new \Model\LandingPage\PageModel() ;
        $default_page_model = new \Model\DefaultModule\PageModel();
        $page = $page_model->getPage() ;
        \ISOPHP\js_core::$console->log('ICP', $page) ;
        $res = new \Controller\Result() ;
        $res->page = $page ;
        $res->type = 'view' ;
        $res->view_control = 'LandingPage' ;
        $res->view = 'LandingPage.php' ;
        $res->post_template = array();

        if ($pageVars['route']['action'] == 'terms') {
            $res->view = 'TermsPage.php' ;
            $res->post_template[] = $page_model->showLandingPage($pageVars, 'TermsPage.php' );
        } else if ($pageVars['route']['action'] == 'contact') {
            $res->view = 'ContactPage.php' ;
            $res->post_template[] = $page_model->showLandingPage($pageVars, 'ContactPage.php' );
        } else if ($pageVars['route']['action'] == 'about') {
            $res->view = 'AboutPage.php' ;
            $res->post_template[] = $page_model->showLandingPage($pageVars, 'AboutPage.php' );
        } else if ($pageVars['route']['action'] == 'affiliates') {
            $res->view = 'AffiliatesPage.php' ;
            $res->post_template[] = $page_model->showLandingPage($pageVars, 'AffiliatesPage.php' );
        } else if ($pageVars['route']['action'] == 'team') {
            $res->view = 'TeamPage.php' ;
            $res->post_template[] = $page_model->showLandingPage($pageVars, 'TeamPage.php' );
        } else if ($pageVars['route']['action'] == 'privacy') {
            $res->view = 'PrivacyPage.php' ;
            $res->post_template[] = $page_model->showLandingPage($pageVars, 'PrivacyPage.php' );
        } else if ($pageVars['route']['action'] == 'careerswithus') {
            $res->view = 'CareersWithUsPage.php' ;
            $res->post_template[] = $page_model->showLandingPage($pageVars, 'CareersWithUsPage.php' );
        } else if ($pageVars['route']['action'] == 'show') {
            $res->view = 'LandingPage.php' ;
            $res->post_template[] = $page_model->showLandingPage($pageVars, 'LandingPage.php' );
        }

        $res->post_template[] = $page_model->bindButtons() ;
        $res->post_template[] = $default_page_model->bindMenu() ;

        \ISOPHP\js_core::$console->log('LandingPage Con', $res) ;
        return $res ;
    }

}


// WEBPACK FOOTER //
// app/LandingPage/Controller/LandingPageController.php